import { Skeleton } from '@/components/ui/skeleton';

export function FormFillingSkeleton() {
	return (
		<main className="flex h-full min-h-screen w-full flex-col bg-white">
			{/* Header Section */}
			<div className="flex items-center justify-end gap-6 p-6 pb-0 md:h-16">
				<div className="size-8" />
			</div>

			{/* Main Content Container - matching production width */}
			<div
				className="relative z-10 mx-auto h-auto rounded-md border border-transparent bg-white md:my-[31px] md:border-border"
				style={{
					width: '100%',
					maxWidth: '768px',
				}}
			>
				<div className="min-h-screen w-full overflow-hidden p-8 subpixel-antialiased md:min-h-full md:p-16">
					{/* Form Header Section */}
					<div className="flex flex-col gap-2">
						{/* Company Logo - positioned at very top */}
						<Skeleton className="h-20 w-20" />

						{/* Form Title */}
						<Skeleton className="h-10 w-3/4 md:h-14" />
					</div>

					{/* Form Widgets */}
					<div className="my-6 flex w-full flex-wrap items-center gap-4 md:my-8">
						<Skeleton className="h-8 w-32 rounded-full" />
						<Skeleton className="h-8 w-36 rounded-full" />
					</div>

					{/* Spacing */}
					<div className="my-4 md:my-8"></div>

					{/* Form Description */}
					<div className="mb-8 w-full">
						<Skeleton className="h-16 w-full" />
					</div>

					{/* Form Input Fields - alternating patterns with more spacing */}
					<div className="mb-8 mt-10 flex flex-col gap-8">
						{/* Long Input - Email Field */}
						<div className="flex flex-col gap-2">
							<Skeleton className="h-4 w-20" />
							<Skeleton className="h-10 w-full" />
						</div>
						<div className="flex flex-col gap-2">
							<Skeleton className="h-4 w-20" />
							<Skeleton className="h-10 w-full" />
						</div>

						{/* Long Input - Text Area Field */}
						<div className="flex flex-col gap-2">
							<Skeleton className="h-4 w-32" />
							<Skeleton className="h-24 w-full" />
						</div>

						{/* Fixed Width Short Input - Phone Field */}
						<div className="flex flex-col gap-2">
							<Skeleton className="h-4 w-24" />
							<Skeleton className="h-10 w-48" />
						</div>
					</div>

					{/* Submit Button */}
					<div className="flex flex-col gap-2">
						<Skeleton className="h-12 w-32 rounded" />
					</div>
				</div>
			</div>

			{/* Watermark */}
			<div className="relative z-20 mb-8 mt-12 flex items-center justify-center md:mb-16 md:mt-4">
				<div className="flex items-center gap-2">
					<Skeleton className="h-4 w-20" />
					<Skeleton className="h-5 w-16" />
					<Skeleton className="h-5 w-5" />
				</div>
			</div>
		</main>
	);
}
